import { Action } from '@ngrx/store';

export const GET_HOTEL_DETAIL = '[Hotel Detail] Get hotel detail';
export const GET_HOTEL_DETAIL_FAIL = '[Hotel Detail] Get Hotel Detail Fail';
export const GET_HOTEL_DETAIL_SUCCESS = '[Hotel Detail] Get hotel detail success';
export const RESTORE_HOTEL_DETAIL = '[Hotel Detail] Restore hotel detail';
export const RESTORE_HOTEL_DETAIL_SUCCESS = '[Hotel Detail] Restore hotel detail success';
export const CLEAR_HOTEL_DETAILS = '[Hotel Detail] Clear hotel detail';

export class GetHotelDetail implements Action {
  readonly type = GET_HOTEL_DETAIL;
  constructor(public payload: number) {}
}

export class GetHotelDetailSuccess implements Action {
  readonly type = GET_HOTEL_DETAIL_SUCCESS;
  constructor(public payload: any) {}
}

export class RestoreHotelDetail implements Action {
  readonly type = RESTORE_HOTEL_DETAIL;
}

export class RestoreHotelDetailSuccess implements Action {
  readonly type = RESTORE_HOTEL_DETAIL_SUCCESS;
  constructor(public payload: any) {}
}

export class ClearHotelDetail implements Action {
  readonly type = CLEAR_HOTEL_DETAILS;
}

export class GetHotelDetailFail implements Action {
  readonly type = GET_HOTEL_DETAIL_FAIL;
  constructor(public payload: any) {}
}

export type HotelDetailsActions =
  | GetHotelDetail
  | GetHotelDetailSuccess
  | RestoreHotelDetail
  | RestoreHotelDetailSuccess
  | ClearHotelDetail
  | GetHotelDetailFail;
